import { useState, useMemo } from 'react'
import { CustomVerseEditorMenu, InsertCustomVerseMenu } from './CustomVerses'
import { stylizedVersesAtom } from 'atoms'
import { useRecoilValue } from 'recoil'

export const InsertMenu = ({ setShow }) => {
  const verses = useRecoilValue(stylizedVersesAtom)
  const [creatingVerse, setCreatingVerse] = useState(false)

  const stylizedVersesList = useMemo(
    () => verses?.stylizedVerses || [],
    [verses],
  )

  const renderContent = () => {
    return creatingVerse ? (
      <CustomVerseEditorMenu
        setCreatingVerse={(value) => setCreatingVerse(value)}
        stylizedVerse={true}
      />
    ) : (
      <InsertCustomVerseMenu
        setShow={setShow}
        setCreatingVerse={(value) => setCreatingVerse(value)}
        verses={stylizedVersesList}
        isCustom={false}
      />
    )
  }

  return <>{renderContent()}</>
}

export default InsertMenu
